import {Block} from 'jsxstyle'
import React from 'react'
import {ReactComponent as BurgerMenuIcon} from '../../../common/assets/burger-menu-icon.svg'

interface SidebarMenuButtonProps {
  sidebarVisible: boolean
  setSidebarVisible: (visible: boolean) => void
}

const SidebarMenuButton: React.FC<SidebarMenuButtonProps> = ({sidebarVisible, setSidebarVisible}) => {
  return (
    <Block
      padding="12px 16px"
      props={{
        onClick: () => setSidebarVisible(!sidebarVisible),
      }}
    >
      <BurgerMenuIcon width="24px" height="24px" fill={sidebarVisible ? '#1E90FF' : '#333'} style={{cursor: 'pointer'}} />
    </Block>
  )
}

export default SidebarMenuButton
